import { render } from "./LiensComponents.vue?vue&type=template&id=5fa57a32"
import script from "./LiensComponents.vue?vue&type=script&lang=js"
export * from "./LiensComponents.vue?vue&type=script&lang=js"

import "./LiensComponents.vue?vue&type=style&index=0&id=5fa57a32&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/Genesii/COLON/wonderful-colon-sg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__